// Enable dark mode
// document.documentElement.classList.add('cc--darkmode');

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },
        analytics: {},
        marketing: {}
    },
    language: {
        default: "cs",
        autoDetect: "browser",
        translations: {
            cs: {
                consentModal: {
                    title: "Používáme cookies 🍪",
                    description: "Soubory cookie používáme k&nbsp;analýze údajů o&nbsp;návštěvnících, ke zlepšení webových stránek, k&nbsp;zobrazení personalizovaného obsahu a&nbsp;obecně k&nbsp;tomu, abychom vám poskytli skvělý zážitek z&nbsp;webu.",
                    acceptAllBtn: "Přijmout vše",
                    acceptNecessaryBtn: "Pouze nezbytné",
                    showPreferencesBtn: "Nastavení",
                    // footer: "<a href=\"#link\">Zásady ochrany osobních údajů</a>\n<a href=\"#link\">Obchodní podmínky</a>"
                },
                preferencesModal: {
                    title: "Nastavení cookies",
                    acceptAllBtn: "Přijmout vše",
                    acceptNecessaryBtn: "Pouze nezbytné",
                    savePreferencesBtn: "Uložit nastavení",
                    closeIconLabel: "Zavřít okno",
                    serviceCounterLabel: "Služba|Služby",
                    sections: [
                        {
                            title: "Co jsou cookies?",
                            description: "Soubory cookie používáme k analýze údajů o návštěvnících, ke zlepšení webových stránek a k tomu, abychom vám poskytli skvělý zážitek z webu. Pro nejlepší funkčnost doporučujeme povolit všechny typy."
                        },
                        {
                            title: "Technické cookies <span class=\"pm__badge\">Trvale zapnuto</span>",
                            description: "Tyto cookies jsou nezbytné pro správné fungování webu a nelze je vypnout. Cookies, které mají životnost po dobu návštěvy uživatele na webu jsou odstraněny vypnutím prohlížeče.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Cookies pro analýzu nám pomáhají pochopit, jak návštěvníci interagují s našimi webovými stránkami. Tyto informace používáme k vylepšení našich služeb a obsahu.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: 'Marketingové cookies',
                            description: 'Marketingové cookies se používají ke sledování návštěvníků na webových stránkách. Cílem je zobrazovat reklamy, které jsou relevantní a zajímavé pro jednotlivé uživatele a tím zvyšovat hodnotu pro inzerenty a zároveň zlepšovat zážitek uživatelů.',
                            linkedCategory: "marketing"
                        }
                        // {
                        //     title: "More information",
                        //     description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href=\"#yourdomain.com\">contact me</a>."
                        // }
                    ]
                }
            }
        }
    },

    onFirstConsent: () => {
        dataLayer.push({ event: 'consent_update' });
    },
    
    onConsent: () => {
        gtag('consent', 'update', {
            analytics_storage: CookieConsent.acceptedCategory('analytics')
                ? 'granted' : 'denied',
            ad_storage: CookieConsent.acceptedCategory('marketing')
                ? 'granted' : 'denied',
            ad_user_data: CookieConsent.acceptedCategory('marketing')
                ? 'granted' : 'denied',
            ad_personalization: CookieConsent.acceptedCategory('marketing')
                ? 'granted' : 'denied'
        });
    },

    onChange: ({ changedCategories }) => {
        if (changedCategories.includes('analytics')) {
            gtag('consent', 'update', {
                analytics_storage: CookieConsent.acceptedCategory('analytics')
                    ? 'granted' : 'denied'
            });
        }
        if (changedCategories.includes('marketing')) {
            const m = CookieConsent.acceptedCategory('marketing');
            gtag('consent', 'update', {
                ad_storage: m ? 'granted' : 'denied',
                ad_user_data: m ? 'granted' : 'denied',
                ad_personalization: m ? 'granted' : 'denied'
            });
        }
        dataLayer.push({ event: 'consent_update' });
    }
});